export function push(...args) {

  // Break eventual reactive objects
  args = JSON.parse(JSON.stringify(args))

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(...args)
}


/**
 * @param {{name: string; id: string; data?: {[key: string]: unknown}}} arguments
 */
export function pushEvent({ name, id, data }) {
  const convertedData = Object.entries(data)
    .sort(([a]) => a === 'user_group' ? -1 : 1) // We always want 'user_group' to be first
    .reduce((current, [key, value], index) => {
      const nameKey = `event_parameter_name_${index + 1}`
      const valueKey = `event_parameter_value_${index + 1}`

      return {
        ...current,
        [nameKey]: key,
        [valueKey]: value,
      }
    }, {})

  push({
    event: 'event',
    event_id: id,
    event_name: name,
    ...convertedData,
  })
}